import React, { useLayoutEffect, useRef, useState } from "react";

type TruncatedTooltipCellProps = {
  text: string | null | undefined;
  /** Optional class on the outer wrapper (e.g. for max-width via CSS) */
  className?: string;
  emptyLabel?: string;
};

/**
 * Single-line ellipsis; when text is clipped, a themed tooltip shows full content on hover.
 */
const TruncatedTooltipCell = ({
  text,
  className = "",
  emptyLabel = "—",
}: TruncatedTooltipCellProps) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const value = text == null || text === "" ? "" : String(text);
  const showEmpty = value === "";

  useLayoutEffect(() => {
    const el = textRef.current;
    if (!el || value === "") {
      setIsTruncated(false);
      return;
    }
    const measure = () => {
      setIsTruncated(el.scrollWidth > el.clientWidth + 1);
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [value]);

  return (
    <div className={`jobs-clip-wrap ${className}`.trim()}>
      <span
        ref={textRef}
        className="jobs-clip-text"
        title={isTruncated && value ? value : undefined}
      >
        {showEmpty ? emptyLabel : value}
      </span>
      {isTruncated && value ? (
        <div className="jobs-tooltip-bubble" role="tooltip">
          {value}
        </div>
      ) : null}
    </div>
  );
};

export default TruncatedTooltipCell;
